/* ================================================== */
/* COMPONENTS > Menu > hide menu on scroll
/* ================================================== */

var previousScroll = 0;

function hideMenuOnScroll() {
	var scroll      = $(window).scrollTop(),
		selector    = (breakpointXs) ? $('.navbar-header') : $('.navbar'),
		scrollClass = 'on-scroll',
		begin       = (breakpointXs) ? $('.navbar-header').outerHeight() : $('.navbar').outerHeight();

	if (scroll <= begin || (scroll + $(window).height()) == $(document).height()) {
		if ($(selector).hasClass(scrollClass)) {
			$(selector).removeClass(scrollClass);
		}
	} else if (scroll > begin && scroll > previousScroll){
		if (!$(selector).hasClass(scrollClass) && !$('body').hasClass('mobile-menu-open')) {
			$(selector).addClass(scrollClass);
		}
	} else if (scroll > begin) {
		if ($(selector).hasClass(scrollClass)) {
			$(selector).removeClass(scrollClass);
		}
	}

	previousScroll = scroll;
}

// Call function on events
$(document).ready(hideMenuOnScroll());
$(window).on('scroll resize orientationchange', function(){
	hideMenuOnScroll();
});


/* ================================================== */
/* COMPONENTS > Menu > mobile
/* ================================================== */

$(document).ready(function() {

	var scrollTop;
	$('.navbar-header.visible-xs button').click(function() {
		if (breakpointXs) {
			// Keep scroll position
			if ($(this).attr('aria-expanded') == 'false') {
				scrollTop = $(window).scrollTop();
				setTimeout(function() {
					$('body').addClass('mobile-menu-open');
				}, 1000);
			} else {
				$('body').removeClass('mobile-menu-open');
				$(window).scrollTop(scrollTop);
				setTimeout(function() {
					$('.navbar-header').removeClass('on-scroll');
				}, 1);
				scrollTop = 0;
			}

			// Toggle menu
			$(this)
				.toggleClass('open')
				.attr('aria-expanded', ($(this).attr('aria-expanded') == 'false') ? 'true' : 'false');
			$('#navbar').toggleClass('open');

			// Update accessibility
			var $dropdownToggle = $('#navbar .dropdown.active.visible-xs > .dropdown-toggle');
			if ($dropdownToggle.length) {
				$dropdownToggle.attr('aria-expanded', ($dropdownToggle.attr('aria-expanded') == 'false') ? 'true' : 'false');
			}
		}
	});

});